import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'
import { Text } from '@wartek-id/text-v1'

import type { StatusPelaksanaanPraktikKinerja } from 'types/kinerja-penilik-pegawai'

const getBadgeProps = (
  state: StatusPelaksanaanPraktikKinerja
): { text: string; variant: BadgeProps['variant'] } => {
  switch (state) {
    case 'DISKUSI_PERSIAPAN':
      return {
        text: 'Isi sembari diskusi bersama Tim Kinerja',
        variant: 'informational',
      }
    case 'PENDAMPINGAN_SEKOLAH':
      return {
        text: 'Isi sembari melakukan pendampingan.',
        variant: 'informational',
      }
    case 'DISKUSI_TINDAK_LANJUT':
      return {
        text: 'Diskusi bersama Tim Kinerja. Diskusi akan diberikan hasil pemantauan.',
        variant: 'informational',
      }
    case 'DISKUSI_TINDAK_LANJUT_PENILAIAN':
      return {
        text: 'Menunggu aksi dari Tim Kinerja',
        variant: 'neutral',
      }
    case 'UPAYA_TINDAK_LANJUT':
      return {
        text: 'Lakukan upaya. Lalu, isi apa saja upaya yang sudah dilakukan.',
        variant: 'informational',
      }
    case 'REFLEKSI_TINDAK_LANJUT':
      return {
        text: 'Isi refleksi. Pengisian akan diberikan hasil pemantauan.',
        variant: 'informational',
      }
    case 'REFLEKSI_TINDAK_LANJUT_PENILAIAN':
      return { text: 'Selesai', variant: 'success' }
    case 'SELESAI':
      return { text: 'Selesai', variant: 'success' }
  }
}

export function PelaksanaanPraktikKinerjaStatusBadge({
  state,
  disabled,
  done,
  appeal,
}: {
  state: StatusPelaksanaanPraktikKinerja
  disabled?: boolean
  done?: boolean
  appeal?: boolean
}) {
  const badgeProps = getBadgeProps(state)

  if (!badgeProps) {
    return null
  }

  if (disabled) {
    return <Text variant="body-sm">{badgeProps.text}</Text>
  }

  if (appeal) {
    return (
      <Badge variant="neutral" className="w-fit">
        Perubahan sedang diajukan
      </Badge>
    )
  }

  if (done) {
    return (
      <Badge variant="success" className="w-fit">
        Selesai
      </Badge>
    )
  }

  return (
    <Badge variant={badgeProps.variant} className="w-fit">
      {badgeProps.text}
    </Badge>
  )
}

export default PelaksanaanPraktikKinerjaStatusBadge
